import { Component, HostListener, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DefaultAltitudesModel } from 'src/app/models/configuration';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ProjectService } from 'src/app/services/project.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-default-altitudes',
  templateUrl: './default-altitudes.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class DefaultAltitudesComponent implements OnInit {

  configurationController : ConfigurationService;
  form: FormGroup;
  constructor(configurationController : ConfigurationService,
    private projectService : ProjectService,
    private utilsService : UtilsService,
    public bsModalRef : BsModalRef) {
      this.configurationController = configurationController;
    }

  ngOnInit(): void {
    this.configurationController.saveChangesState();
    this.form = new FormGroup({
      singleLevelAltitudeFT: new FormControl(this.configurationController.currentConfiguration.defaultAltitudes.singleLevelAltitudeFT,[Validators.min(100),Validators.max(60000)]),
      singleLevelAltitudeM: new FormControl(this.configurationController.currentConfiguration.defaultAltitudes.singleLevelAltitudeFT,[Validators.min(30.48),Validators.max(18288)]),

      maxAltitudeFT: new FormControl(this.configurationController.currentConfiguration.defaultAltitudes.maxAltitudeFT,[Validators.min(0),Validators.max(60000)]),
      maxAltitudeM: new FormControl(this.configurationController.currentConfiguration.defaultAltitudes.maxAltitudeM,[Validators.min(0),Validators.max(18288)]),

      altitudeIncrementFT: new FormControl(this.configurationController.currentConfiguration.defaultAltitudes.altitudeIncrementFT,[Validators.min(100),Validators.max(60000)]),
      altitudeIncrementM: new FormControl(this.configurationController.currentConfiguration.defaultAltitudes.altitudeIncrementM,[Validators.min(30.48),Validators.max(18288)] ),

      minAltitudeFT: new FormControl(this.configurationController.currentConfiguration.defaultAltitudes.minAltitudeFT,[Validators.min(0),Validators.max(60000)]),
      minAltitudeM: new FormControl(this.configurationController.currentConfiguration.defaultAltitudes.minAltitudeM,[Validators.min(0),Validators.max(18288)]),
    },{validators : this.minMaxAltitudeValidator})
  }
  minMaxAltitudeValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const min = control.get('minAltitudeFT');
    const max = control.get('maxAltitudeFT');

    return min && max && min.value >= max.value ? { minMaxError: true } : null;
  };
  @HostListener('document:keydown.escape', ['$event']) 
  onEscape(event: KeyboardEvent) {
    this.cancelConfiguration(false); // escape key already hides the modal
  }

  cancelConfiguration(hideModal: boolean = true):void {
    this.configurationController.cancelConfigurationPopup();
    hideModal? this.bsModalRef.hide(): false;
  }

  saveConfiguration():void {
    if (!this.projectService.projectEditable()) {
      this.cancelConfiguration();
      return;
    }
    this.configurationController.saveConfigurationPopup(this.form);
    this.bsModalRef.hide();
  }

  updateSingleLevelAltitudeValue(type: string,value: number){
    if(type == "m"){
      this.configurationController.currentConfiguration.defaultAltitudes.singleLevelAltitudeM = this.utilsService.feetToMeters(value);
      this.configurationController.currentConfiguration.defaultAltitudes.singleLevelAltitude = value;
    }
    else if(type == "ft"){
      this.configurationController.currentConfiguration.defaultAltitudes.singleLevelAltitudeFT = this.utilsService.metersToFeet(value);
      this.configurationController.currentConfiguration.defaultAltitudes.singleLevelAltitude = this.utilsService.metersToFeet(value);
    }
    else{
      //ERROR
    }
  }

  updateMaxAltitudeValue(type: string,value: number){
    if(type == "m"){
      this.configurationController.currentConfiguration.defaultAltitudes.maxAltitudeM = this.utilsService.feetToMeters(value);
      this.configurationController.currentConfiguration.defaultAltitudes.maxAltitude = value;
    }
    else if(type == "ft"){
      this.configurationController.currentConfiguration.defaultAltitudes.maxAltitudeFT = this.utilsService.metersToFeet(value);
      this.configurationController.currentConfiguration.defaultAltitudes.maxAltitude = this.utilsService.metersToFeet(value);
    }
    else{
      //ERROR
    }
  }

  updateAltitudeIncrementValue(type: string,value: number){
    if(type == "m"){
      this.configurationController.currentConfiguration.defaultAltitudes.altitudeIncrementM = this.utilsService.feetToMeters(value);
      this.configurationController.currentConfiguration.defaultAltitudes.altitudeIncrement = value;
    }
    else if(type == "ft"){
      this.configurationController.currentConfiguration.defaultAltitudes.altitudeIncrementFT = this.utilsService.metersToFeet(value);
      this.configurationController.currentConfiguration.defaultAltitudes.altitudeIncrement = this.utilsService.metersToFeet(value);
    }
    else{
      //ERROR
    }
  }

  updateMinAltitudeValue(type: string,value: number){
    if(type == "m"){
      this.configurationController.currentConfiguration.defaultAltitudes.minAltitudeM = this.utilsService.feetToMeters(value);
      this.configurationController.currentConfiguration.defaultAltitudes.minAltitude = value;
    }
    else if(type == "ft"){
      this.configurationController.currentConfiguration.defaultAltitudes.minAltitudeFT = this.utilsService.metersToFeet(value);
      this.configurationController.currentConfiguration.defaultAltitudes.minAltitude = this.utilsService.metersToFeet(value);
    }
    else{
      //ERROR
    }
  }

  retoreDefaults(){
    let defaultAltitudesConfiguration: DefaultAltitudesModel = new DefaultAltitudesModel();

    defaultAltitudesConfiguration.singleLevelAltitude = 30000;
    defaultAltitudesConfiguration.singleLevelAltitudeM = 9144;
    defaultAltitudesConfiguration.singleLevelAltitudeFT = 30000;
    defaultAltitudesConfiguration.maxAltitudeM = 18288;
    defaultAltitudesConfiguration.maxAltitudeFT = 60000;
    defaultAltitudesConfiguration.altitudeIncrement = 10000;
    defaultAltitudesConfiguration.altitudeIncrementM = 3048;
    defaultAltitudesConfiguration.altitudeIncrementFT = 10000;
    defaultAltitudesConfiguration.minAltitude = 0;
    defaultAltitudesConfiguration.minAltitudeM = 0;
    defaultAltitudesConfiguration.minAltitudeFT = 0;


    this.configurationController.currentConfiguration.defaultAltitudes = defaultAltitudesConfiguration;
  }

}
